import { LosseLink, LossePlaatjie, useLoaderData } from '@ubo/losse-sjedel'
import clsx from 'clsx'
import dayjs from 'dayjs'
import Animated from '~/components/elements/Animated'
import Content from '~/components/elements/Content'
import type { Page_Flexcontent_Flex_Hubspot } from '~/graphql/types'
import { type ProfilePageLoaderData } from '~/services/hubspot.server'
import { phases } from './HubspotBanner'

export default function HubspotMatches({ fields }: { fields: Page_Flexcontent_Flex_Hubspot }) {
  const { hubspotData: profile } = useLoaderData<ProfilePageLoaderData>()
  const currentPhase = phases.find((phase) => phase.id.some((id) => String(id) === profile.deals[0].properties.dealstage))
  const matches = profile.deals.filter(
    (deal) => deal.properties.carerix_first_meeting_date && currentPhase.id.some((id) => id === Number(deal.properties.dealstage))
  )
  return (
    <section data-component="HubspotMatches" className="overflow-x-clip">
      {matches.map((deal, index) => (
        <div
          id={deal.id}
          key={deal.id}
          className={clsx(index % 2 === 0 ? 'bg-site-secondair' : 'bg-white', 'section--large--pt section--large--pb')}
        >
          <div className="container">
            <div className="max-w-[1119px] mx-auto">
              <div>
                <Animated delay={100}>
                  <h2 className="border-text mb-4 md:-mb-2 lg:-mb-4 title--semi-unit text-transparent md:text-center">{fields.title}</h2>
                </Animated>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-y-10 gap-x-16 lg:gap-x-24">
                <div className={clsx(index % 2 === 0 ? '' : 'order-last', 'max-md:order-last')}>
                  <Animated delay={150}>
                    <div className="relative h-[400px] w-full">
                      <Animated delay={300}>
                        <div
                          className={clsx(
                            index % 2 === 0 ? '-left-[57px]' : '-right-[57px]',
                            'h-[76px] w-[114px] z-20 bg-site-accent absolute top-[38px] lg:-top-[38px]'
                          )}
                        />
                      </Animated>

                      <div className="absolute w-full h-full z-10 left-0 top-0 bg-site-grey" />

                      <LossePlaatjie className="h-full w-full relative z-30 object-cover" src={fields.image} />
                    </div>
                  </Animated>
                </div>
                <Animated delay={300}>
                  <div className="flex flex-col justify-center gap-y-6 sm:gap-y-10">
                    <Content className="children-p:text-lg children-strong:text-site-base">
                      {fields.description
                        ?.replace('{meeting_time}', dayjs(deal.properties.carerix_first_meeting_date).format('dddd DD MMMM [om] HH:mm'))
                        ?.replaceAll('{meeting_name}', deal.properties.carerix_first_meeting_location_name)
                        ?.replace('{meeting_location}', deal.properties.carerix_first_meeting_location)
                        ?.replace('{meeting_city}', deal.properties.carerix_first_meeting_city)}
                    </Content>
                    <div className="flex sm:flex-row flex-col items-center gap-y-2 gap-x-4">
                      <LosseLink
                        target="_blank"
                        to={`https://www.google.com/maps/dir//${deal.properties.carerix_first_meeting_location}`}
                        className="btn--conversion max-sm:w-full"
                      >
                        Plan je route in
                      </LosseLink>
                      {deal.company.website && (
                        <LosseLink target="_blank" to={deal.company.website} className="btn--outline--black max-sm:w-full">
                          Bekijk website
                        </LosseLink>
                      )}
                    </div>
                  </div>
                </Animated>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  )
}
